import styled from '@emotion/styled'

export const MenuButtonWrapper = styled.span`
  rotate: 90deg;
`
